import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { isFeatureUsageLimited } from "@app/shared/payment/helper/feature.helper";
import { IFeature } from "@app/shared/payment/interfaces/feature.interface";
import { TranslatePipe } from "@ngx-translate/core";
import { DecimalPipe, NgForOf, NgIf, UpperCasePipe } from "@angular/common";
import { SxwTooltipDirective } from "@kernel/tools/tooltip/sxw-tooltip.directive";

@Component({
  selector: "app-plan-features-list",
  templateUrl: "./plan-features-list.component.html",
  styleUrls: ["./plan-features-list.component.scss"],
  imports: [TranslatePipe, NgForOf, NgIf, SxwTooltipDirective, UpperCasePipe, DecimalPipe],
})
export class PlanFeaturesListComponent implements OnChanges {
  @Input() planFeatures: IFeature[] = [];
  @Input() smallerPlanFeatures?: IFeature[];
  @Input() smallerPlanName?: string;
  @Input() showCheckIcons = true;
  @Input() showSubtitles = true;
  @Input() showAdditionalFeatures = false;

  public limitableFeatures: IFeature[] = [];
  public features: IFeature[] = [];
  public includeAllInSmallerPlan = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["planFeatures"] || changes["smallerPlanFeatures"]) {
      this.initFeatures(this.planFeatures, this.smallerPlanFeatures);
    }
  }

  private initFeatures(features: IFeature[], smallerPlanFeatures?: IFeature[]) {
    const maybeOmittedFeatures = new Set<IFeature>();
    const includeAllInSmallerPlan =
      smallerPlanFeatures?.every(smallerPlanFeat => {
        if (isFeatureUsageLimited(smallerPlanFeat.key)) {
          return true;
        }
        const feat = features.find(feat => feat.key === smallerPlanFeat.key);
        if (feat) {
          maybeOmittedFeatures.add(feat);
        }
        return !!feat;
      }) ?? false;

    this.includeAllInSmallerPlan = includeAllInSmallerPlan;
    this.features = [];
    this.limitableFeatures = [];

    features.forEach(feat => {
      if (isFeatureUsageLimited(feat.key)) {
        this.limitableFeatures.push(feat);
      } else if (!includeAllInSmallerPlan || !maybeOmittedFeatures.has(feat)) {
        this.features.push(feat);
      }
    });
  }
}
